/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState } from 'react';

import { getComments } from '../services/workReport';
import LoaderContext from '../context/LoaderProvider';

import useToast from './useToast';

const useComment = (dailyWorkReportId, monthly) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [error, setError] = useState(false);
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const getListComments = () => {
    setLoading(true);
    const skip = pageIndex + 1;

    getComments(dailyWorkReportId, skip, 10, monthly)
      .then((res) => {
        const reversedItems = res.items.reverse();

        setComments([...reversedItems, ...comments]);
        setPageIndex(res.pageIndex);
        setHasNextPage(res.totalPages ? res.pageIndex !== res.totalPages : false);
        setLoader(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoader(false);
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
        setError(true);
      });
  };

  const refreshInitComments = () => {
    setLoading(true);
    const skip = 1;

    getComments(dailyWorkReportId, skip, 10, monthly)
      .then((res) => {
        const reversedItems = res.items.reverse();

        setComments([...reversedItems]);
        setPageIndex(res.pageIndex);
        setHasNextPage(res.pageIndex !== res.totalPages);
        setLoader(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoader(false);
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
        setError(true);
      });
  };

  const reset = () => {
    setComments([]);
    setPageIndex(0);
    setHasNextPage(false);
  };

  return {
    loading,
    comments,
    hasNextPage,
    error,
    loadMore: getListComments,
    refreshInitComments,
    reset
  };
};

export default useComment;
